import getOptionsByActiveCountry from 'utils/getOptionsByActiveCountry';

export default function (allDataLocationNodes) {
  const activeCountryLocations = getOptionsByActiveCountry(allDataLocationNodes);

  const uniqueCities = activeCountryLocations.reduce((acc, location) => {
    if (!acc.some(x => x.name === location.city))
      acc.push({
        id: location.city.toLowerCase(),
        name: location.city,
      });

    return acc;
  }, []);
  const cities = uniqueCities.sort((a, b) => a.name?.localeCompare(b.name));

  return cities;
}
